<ng-container *ngIf="object$ | async as obj">
  <pw-view-title> QR-Code </pw-view-title>

  <h2>{{ obj.TEXT }}</h2>
  <qrcode [qrdata]="String(obj.OBJECT_ID)" [width]="256"></qrcode>
</ng-container>
